import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntMonthCalendarComponent} from "./int-month-calendar.component";
import {DateControllerModule, IntMonthListModule, IntYearSelectorModule} from "../../entities";

@NgModule({
  imports: [
    CommonModule,
    IntYearSelectorModule,
    DateControllerModule,
    IntMonthListModule
  ],
  declarations: [
    IntMonthCalendarComponent
  ],
  exports: [
    IntMonthCalendarComponent
  ]
})
export class IntMonthCalendarModule {}
